export function existTemperature(temperature) {
    if (temperature === null) {
        return false;
    }
    if (temperature === undefined) {
        return false;
    }
    if (temperature === '') {
        return false;
    }
    return true;
}
export function getTemperature(temperature, default_temperature) {
    if (!existTemperature(temperature)) {
        return default_temperature;
    }
    return +temperature;
}
export function getTemperatureRange(min_temperature, max_temp_temperature, default_min_temperature, default_max_temperature) {
    if (existTemperature(min_temperature) && existTemperature(max_temp_temperature)) {
        return {
            min_temperature: +min_temperature,
            max_temperature: +max_temp_temperature,
        };
    }
    if (existTemperature(min_temperature) && !existTemperature(max_temp_temperature)) {
        return {
            min_temperature: +min_temperature,
            max_temperature: default_max_temperature,
        };
    }
    if (!existTemperature(min_temperature) && existTemperature(max_temp_temperature)) {
        return {
            min_temperature: default_min_temperature,
            max_temperature: +max_temp_temperature,
        };
    }
    return {
        min_temperature: default_min_temperature,
        max_temperature: default_max_temperature,
    };
}
